import { render, staticRenderFns } from "./unitsModal.vue?vue&type=template&id=b1357c9a"
import script from "./unitsModal.vue?vue&type=script&lang=js"
export * from "./unitsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports